import { Injectable } from '@angular/core';
import { map, shareReplay } from 'rxjs/operators';
import { exists } from '../../../../../../../../functions/exists';
import { Observable } from 'rxjs';
import { GlassHouseShelfTalkerCardData } from '../../../../../../../../models/shelf-talkers/glass-house-shelf-talker-card-data';
import type { VariantsGroupedByBrand } from '../../../../../../models/variants-grouped-by-brand';
import { ShelfTalkerCardContentViewModel } from '../../shelf-talker-card-content-view-model';

@Injectable()
export class GlassHouseShelfTalkerContentViewModel extends ShelfTalkerCardContentViewModel {
  public readonly data$: Observable<GlassHouseShelfTalkerCardData | null>;
  public readonly headerText$ = this.data$.pipe(map(data => data?.getCardTitle() ?? ''));
  public readonly headerTextColor$ = this.data$.pipe(map(data => data?.getHeaderTextColor() || '#222222'));
  public readonly accentColor$ = this.data$.pipe(map(data => data?.getAccentColor()));
  public readonly bodyTextColor$ = this.data$.pipe(map(data => data?.getBodyTextColor()));
  public readonly companyLogo$ = this.data$.pipe(map(data => data?.getCompanyLogo()));

  public readonly variantsGroupedByBrandThenSorted$ = this.data$.pipe(
    map(data => data?.getVariantsGroupedByBrandThenSortedBySectionSpecifications()),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly variantsSplitInto6Rows$ = this.variantsGroupedByBrandThenSorted$.pipe(
    map(sortedByBrand => {
      const twoListsPerRow: [VariantsGroupedByBrand, VariantsGroupedByBrand][] = [];
      for (let i = 0; i < sortedByBrand.length; i += 2) {
        const first = sortedByBrand?.[i];
        const second = sortedByBrand?.[i + 1] ?? null;
        if (exists(first) || exists(second)) {
          twoListsPerRow.push([first, second]);
        }
      }
      return twoListsPerRow?.take(6);
    })
  );
}
